import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import PrecioCombustible from './PrecioCombustible';
import ACCESS from '../../../ACCESS.js';

class MotivosRechazo extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'combustible/filter', deleteUrl: 'combustible/delete', deleteField: 'combustible_precio_valor', modUrl: '/Catalogo/PrecioCombustible' },
      TableOp.Table('Actualizacion Precio Combustibles', [
        { label: 'Valor', id: 'combustible_precio_valor' },
        { label: 'Fecha Registro', id: 'updatedAt' },
        { label: 'User', id: 'email' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGOS_PRECIO_COMBUSTIBLE.EDITAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <PrecioCombustible  onSave={() => {this.table()}}></PrecioCombustible>
          }
          {
             
          <this.TableRender  />
          }
        </div>
      </div>
    )
  }
}

export default withRouter(MotivosRechazo)